import { PropsWithChildren, ReactElement } from "react";
import styles from "./ItemContent.module.less";

export type ItemContentProps = {
	icon?: ReactElement;
};

export const ItemContent = (props: PropsWithChildren<ItemContentProps>): ReactElement => {
	const {
		icon,
		children
	} = props;

	return (
		<div className={styles.root}>
			{icon}
			<div className={styles.content}>
				{children}
			</div>
		</div>
	);
};
ItemContent.displayName = "ItemContent";